export function cropText(text: string, maxLength: number): string {
  if (text.length > maxLength) {
    const sliced = text.slice(0, maxLength);
    return `${sliced}…`;
  }
  return text;
}
